const lists = require("@/lists.js");
import { formatTimeToDDMMYYFromString } from "@/timeFunctions.js";

export default class ChatAutoMessenger {

    constructor() {
    }
}

const getPropertyInquryMessage = ({ prospectName, property, periodStart, periodEnd, nrOfGuests }) => {
    var propSubType
    for (let i = 0, n = lists.subPropertyTypeList.length; i < n; i++) {
        if (lists.subPropertyTypeList[i].value == property.genDet.propType.subType) {
            propSubType = lists.subPropertyTypeList[i].text;
            break;
        }
    }
    var address = property.location.address.street + " " + property.location.address.number + ", " + property.location.address.municipality + ".";
    var msg = ""
    if (prospectName) msg += prospectName + " is interested in the " + propSubType + " at " + address
    else msg += "Person is interested in the " + propSubType + " at " + address

    if (periodStart) msg += " Planned move in date: " + formatTimeToDDMMYYFromString(periodStart) + ".";
    if (periodEnd) msg += " Planned move out date:" + formatTimeToDDMMYYFromString(periodEnd) + ".";
    if (nrOfGuests) msg += " There are " + nrOfGuests + " guests."
    return msg;
}

const getInquiryChangeMessage = ({whoChanged})=>{
    var msg = ""
    if(whoChanged) msg += whoChanged + " has edited the offer."
    else msg += "Offer has been edited."
    return msg
}

const getInquiryPriceChangeMessage = ({whoChanged, changedPrice}) =>{
    var msg = ""
    if(whoChanged) msg += whoChanged + " has changed the price of the offer to " + changedPrice
    else msg += " Offer price has changed to " + changedPrice
    return msg
}

const getInquiryPeriodChangeMessage = ({whoChanged, changedMoveInDate, changedMoveOutDate}) =>{
    var msg = ""
    if(whoChanged) {
        msg += whoChanged + " has changed the period to " + formatTimeToDDMMYYFromString(changedMoveInDate) + " - " + formatTimeToDDMMYYFromString(changedMoveOutDate)
    }else{
        msg += " Offer period has changed to " + formatTimeToDDMMYYFromString(changedMoveInDate) + " - " + formatTimeToDDMMYYFromString(changedMoveOutDate)
    }
    return msg
}


export { getPropertyInquryMessage, getInquiryPeriodChangeMessage, getInquiryPriceChangeMessage, getInquiryChangeMessage }







// WEBPACK FOOTER //
// ./src/platform/chat/services/ChatAutoMessenger.js